import $ from 'jquery';
import slick from 'slick-carousel';

$( '.js-logo-slider' ).slick( {
	infinite: true,
	slidesToShow: 6, // Default to 6 logos
	dots: false,
	arrows: false,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	responsive: [
		{
			breakpoint: 992, // Up to 992px
			settings: {
				slidesToShow: 4, // Show 4 logos
			}
		},
		{
			breakpoint: 768, // Up to 768px
			settings: {
				slidesToShow: 3, // Show 3 logos
			}
		},
		{
			breakpoint: 576, // Up to 576px
			settings: {
				slidesToShow: 2, // Show 2 logos
 			}
		}
	]
} );
